/* ==========================================================================
   ALBEUX GRID FX SCRIPT: HOLO SCAN (assets/albeux-grid-fx.js)
   Pairs with albeux-grid-fx.css, read the comment at the top of that file first.
   1. Puts a cover panel on every grid picture: the home page collection tiles, the New In row, and the product photographs on collection pages.
      When a picture is a third on screen the panel is told to play, and the panel is then removed.
      On collection pages the whole ROW plays at once (2 photographs on a phone, 4 on a computer): when one photograph in a row starts, every other photograph in the same row starts with it.
      Safety: a panel is removed after 3.2 seconds whatever happens, and a sweep at 5 and 10 seconds plays any panel that is on screen but has not started.
      After the first cards are marked, the script adds alb-grid-live to <html> so the CSS pre-cover (first paint only) is switched off for good.
      The moment the FIRST row of a collection page starts its sweep, the script announces it (the window event alb:sweep), so the page heading
      (assets/albeux-reveal.js) can start its own reveal on the very same frame and finish at the very same moment.
      (31 Oct 2026, sync fix) The announcement also leaves a timestamp, window.__albSweepAt. This script is loaded before the heading script, so on a slow first visit
      the sweep could already be running before the heading script was ready to hear the event. The heading now reads the timestamp and joins the sweep at the same point.
   2. LEAN (the 3D tilt of the photographs while scrolling) is switched OFF (31 Oct 2026, performance pass).
      It moved every visible photograph in 3D on every scroll frame, which is the heaviest thing on a collection page and made some phones stick.
      To turn it back on: change LEAN_ENABLED below from false to true.
   SPEED (31 Oct 2026): the page is now READ in one go and then WRITTEN in one go (before, every card forced the browser to re-measure the whole page, one card at a time,
   which is what made a collection feel stuck for a moment as it opened).
   Nothing runs for visitors who ask their device for reduced motion. Any error stops the effect and leaves the page as it was.

   HOME PAGE ROW FIX (1 Nov 2026): Handbags, Mini Bags and Fine Leather now sweep from LEFT TO RIGHT, and the sweep can no longer be lost.
   What was wrong:
   a) The 5 second and 10 second safety sweep only looked at the UP-DOWN position. On a phone the Handbags, Mini Bags and Fine Leather tiles wait off to the right inside the
      swipe row, so the safety sweep played their reveal while they were out of sight. By the time the visitor swiped to them the effect was already used up, and they just sat there.
      Now every home tile is checked sideways as well, so a tile is only played when it can really be seen.
   b) The three tiles had a small staggered delay that made them wait a moment after they arrived. They now start at once.
   c) Their pictures are lazy-loaded, so on a slow connection the sweep could play over a tile that was still empty. The pictures are now fetched quietly once the page has loaded,
      and a tile waits (at most 1.2 seconds) for its own picture before it sweeps.
   d) As a second safety, swiping the row now also checks the tiles (in case a phone does not report a tile coming into view inside a swipe row), and a tile starts as soon as an eighth
      of it is visible, so the sweep goes along with the swipe instead of waiting for it to finish.
   e) However it goes wrong, a panel is removed at the latest 5 seconds after it was told to play, so a tile can never stay covered.
   The other tiles (Women, Men, Work Bags, Travel, The New Silhouette) and all collection pages keep their top to bottom sweep exactly as before.
   ========================================================================== */
(function () {
  if (window.__albeuxHolo) return;
  window.__albeuxHolo = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var LEAN_ENABLED = false;

  var HOME = '.albeux-coll__card, .albeux-feature__tile';
  var GRID = 'main[data-template^="collection"] .product-grid__item .card-gallery';
  var CARDS = HOME + ', ' + GRID;
  var ITEMS = 'main[data-template^="collection"] .product-grid__item';
  /* The three tiles that sweep from left to right: Handbags, Mini Bags, Fine Leather (every tile of the New Silhouette row except the first) */
  var LR = '.albeux-feature__tile[data-alb-dir="lr"], .albeux-feature__tile:not(:first-child)';
  var TRACKS = '.albeux-feature__track, .albeux-coll__track';
  var LEAN_OK = LEAN_ENABLED && !(window.matchMedia && window.matchMedia('(min-width: 750px)').matches);
  var pending = [];
  var announced = false;

  /* ---------- 1. Holo scan ---------- */
  function isGridHost(h) {
    try { return h.matches(GRID); } catch (e) { return false; }
  }

  function isLR(h) {
    try { return h.matches(LR); } catch (e) { return false; }
  }

  /* How much of the tile must be on screen before it plays: a third for most, an eighth for the left-to-right tiles so their sweep travels with the swipe */
  function need(h) {
    return isLR(h) ? 0.12 : 0.3;
  }

  /* The part of this tile (0 to 1) that can be seen right now, sideways as well as up and down */
  function visibleFrac(h) {
    var r = h.getBoundingClientRect();
    var W = window.innerWidth || document.documentElement.clientWidth;
    var H = window.innerHeight || document.documentElement.clientHeight;
    if (r.width <= 0 || r.height <= 0) return 0;
    var w = Math.min(r.right, W) - Math.max(r.left, 0);
    var v = Math.min(r.bottom, H) - Math.max(r.top, 0);
    if (w <= 0 || v <= 0) return 0;
    return (w * v) / (r.width * r.height);
  }

  /* A tile that has not got its picture yet is not swept until it has it (never longer than 1.2 seconds) */
  function pictureReady(host, cb) {
    var im = null;
    try { im = host.querySelector('img'); } catch (e) {}
    if (!im || im.complete) { cb(); return; }
    var fired = false;
    var go = function () { if (fired) return; fired = true; cb(); };
    try { if (im.loading === 'lazy') im.loading = 'eager'; } catch (e) {}
    im.addEventListener('load', go, { once: true });
    im.addEventListener('error', go, { once: true });
    setTimeout(go, 1200);
  }

  function play(host) {
    var o = host.__holo;
    if (!o || o.__run) return;
    o.__run = true;
    var done = function () {
      if (o.parentNode) o.parentNode.removeChild(o);
      if (host.__holo === o) host.__holo = null;
    };
    var go = function () {
      if (!o.parentNode) return;
      o.classList.add('alb-run');
      o.addEventListener('animationend', function (ev) { if (ev.target === o) done(); });
      setTimeout(done, 3200);
    };
    if (isGridHost(host)) {
      go();
    } else {
      pictureReady(host, go);
      /* However it goes, the panel is gone 5 seconds after it was told to play */
      setTimeout(done, 5000);
    }
  }

  /* Tells the page heading that the sweep has just started (once per page) */
  function announce() {
    if (announced) return;
    announced = true;
    /* The timestamp first, so a heading script that is not loaded yet can still join the sweep at the right point */
    try { window.__albSweepAt = performance.now(); } catch (e) {}
    try { window.dispatchEvent(new Event('alb:sweep')); } catch (e) {}
  }

  /* Plays this picture, and on collection pages every other waiting picture in the same row at the same moment.
     All the measuring is done first, then all the playing, so the browser measures the page once, not once per picture. */
  function playRow(host) {
    if (!isGridHost(host)) { play(host); return; }
    pending = pending.filter(function (h) { return h.__holo && !h.__holo.__run && h.isConnected; });
    var top = host.getBoundingClientRect().top;
    var mates = [];
    for (var i = 0; i < pending.length; i++) {
      var h = pending[i];
      if (h === host || !isGridHost(h)) continue;
      if (Math.abs(h.getBoundingClientRect().top - top) < 8) mates.push(h);
    }
    for (var j = 0; j < mates.length; j++) runIO.unobserve(mates[j]);
    play(host);
    for (var k = 0; k < mates.length; k++) play(mates[k]);
    announce();
  }

  var runIO = new IntersectionObserver(function (entries) {
    var hits = [];
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      /* Two thresholds are watched (an eighth and a third); each tile waits for its own */
      if (e.intersectionRatio + 0.001 < need(e.target)) return;
      runIO.unobserve(e.target);
      hits.push(e.target);
    });
    hits.forEach(function (h) {
      if (h.__holo && !h.__holo.__run) playRow(h);
    });
  }, { threshold: [0.12, 0.3] });

  function tag() {
    var list = document.querySelectorAll(CARDS + ':not([data-alb-holo])');
    if (!list.length) { bindTracks(); return; }
    var i;
    /* Read everything first ... */
    var needsPos = [];
    for (i = 0; i < list.length; i++) {
      var isStatic = false;
      try { isStatic = window.getComputedStyle(list[i]).position === 'static'; } catch (e) {}
      needsPos.push(isStatic);
    }
    /* ... then write everything */
    var n = 0;
    for (i = 0; i < list.length; i++) {
      var h = list[i];
      h.setAttribute('data-alb-holo', '1');
      var o = null;
      try {
        if (needsPos[i]) h.style.position = 'relative';
        o = document.createElement('span');
        o.className = 'alb-holo';
        o.setAttribute('aria-hidden', 'true');
        if (isLR(h)) {
          /* Left to right, and no waiting */
          o.className = 'alb-holo alb-holo--lr';
          o.style.setProperty('--alb-d', '0ms');
        } else {
          o.style.setProperty('--alb-d', ((n % 4) * 90) + 'ms');
        }
        o.innerHTML = '<span class="alb-holo__line"></span><span class="alb-holo__ticks"></span>';
        h.appendChild(o);
        h.__holo = o;
        pending.push(h);
        runIO.observe(h);
        n++;
      } catch (err) {
        if (o && o.parentNode) o.parentNode.removeChild(o);
        h.__holo = null;
      }
    }
    tagItems();
    bindTracks();
    warmLater();
  }

  function sweep() {
    var H = window.innerHeight || document.documentElement.clientHeight;
    pending = pending.filter(function (h) { return h.__holo && !h.__holo.__run && h.isConnected; });
    var due = [];
    pending.forEach(function (h) {
      if (isGridHost(h)) {
        var r = h.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0 && r.top < H * 0.8) due.push(h);
      } else if (visibleFrac(h) >= need(h)) {
        /* Home tiles: only when they can really be seen, sideways as well (a tile waiting off to the right inside a swipe row is NOT due) */
        due.push(h);
      }
    });
    due.forEach(function (h) {
      if (h.__holo && !h.__holo.__run) {
        runIO.unobserve(h);
        playRow(h);
      }
    });
  }
  setTimeout(sweep, 5000);
  setTimeout(sweep, 10000);

  /* Second safety for the swipe rows on the home page: while the row is swiped, the waiting tiles are checked (once per frame at most) */
  var trackQueued = false;
  function onTrackScroll() {
    if (trackQueued) return;
    trackQueued = true;
    requestAnimationFrame(function () { trackQueued = false; sweep(); });
  }
  function bindTracks() {
    var list = document.querySelectorAll(TRACKS);
    for (var i = 0; i < list.length; i++) {
      if (list[i].__albScroll) continue;
      list[i].__albScroll = true;
      list[i].addEventListener('scroll', onTrackScroll, { passive: true });
    }
  }

  /* The pictures of the swipe row are lazy-loaded; once the page has loaded and the browser is idle they are fetched quietly, so they are there when the visitor swipes */
  var warmQueued = false;
  function warm() {
    warmQueued = false;
    var imgs = document.querySelectorAll('.albeux-feature__tile img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      try { imgs[i].loading = 'eager'; } catch (e) {}
    }
  }
  function warmLater() {
    if (warmQueued) return;
    warmQueued = true;
    var kick = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
    };
    if (document.readyState === 'complete') kick(); else window.addEventListener('load', kick, { once: true });
  }

  /* ---------- 2. Lean while scrolling (off, see the note at the top) ---------- */
  var items = [];
  var s = 0;
  var lastY = window.pageYOffset || 0;
  var looping = false;
  var itemIO = null;

  if (LEAN_OK) {
    itemIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = items.indexOf(e.target);
        if (e.isIntersecting) {
          if (i < 0) items.push(e.target);
        } else if (i >= 0) {
          items.splice(i, 1);
          e.target.style.transform = '';
          e.target.style.willChange = '';
        }
      });
    }, { rootMargin: '80px 0px 80px 0px' });
  }

  function tagItems() {
    if (!LEAN_OK || !itemIO) return;
    var list = document.querySelectorAll(ITEMS + ':not([data-alb-lean])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-alb-lean', '1');
      itemIO.observe(list[i]);
    }
  }

  function clearAll() {
    for (var i = 0; i < items.length; i++) {
      items[i].style.transform = '';
      items[i].style.willChange = '';
    }
  }

  function step() {
    var y = window.pageYOffset || 0;
    var v = y - lastY;
    lastY = y;
    s += (v - s) * 0.2;
    var a = s * 0.2;
    a = a > 4.5 ? 4.5 : (a < -4.5 ? -4.5 : a);
    if (Math.abs(s) > 0.05 || Math.abs(v) > 0.5) {
      var t = 'perspective(1100px) rotateX(' + a.toFixed(2) + 'deg)';
      for (var i = 0; i < items.length; i++) {
        items[i].style.willChange = 'transform';
        items[i].style.transform = t;
      }
      requestAnimationFrame(step);
    } else {
      s = 0;
      clearAll();
      looping = false;
    }
  }

  function onScroll() {
    if (looping || !items.length) return;
    looping = true;
    lastY = window.pageYOffset || 0;
    requestAnimationFrame(step);
  }

  function hasNewCards(muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('.product-grid__item')) || (n.querySelector && n.querySelector('.product-grid__item'))) return true;
      }
    }
    return false;
  }

  function start() {
    try { tag(); } catch (e) {}
    /* From now on the CSS pre-cover (first paint only) is never used again */
    document.documentElement.classList.add('alb-grid-live');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
  if (LEAN_OK) window.addEventListener('scroll', onScroll, { passive: true });

  var main = document.getElementById('MainContent');
  var queued = false;
  if (main && 'MutationObserver' in window) {
    new MutationObserver(function (muts) {
      if (queued || !hasNewCards(muts)) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; start(); });
    }).observe(main, { childList: true, subtree: true });
  }
})();